import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const FeedbackSection = () => {
  return (
    <Container className="my-5">
        <h2 className="text-center mb-5">Client Feedback</h2>
        <Row className="justify-content-center">
            
            {/* Card 1: Client A */}
            <Col md={6} lg={4} className="mb-4">
                {/* h-100 ensures equal card height, shadow-lg adds a pronounced shadow */}
                <Card className="shadow-lg h-100"> 
                    <Card.Body>
                        <blockquote className="blockquote mb-0">
                            <p className="font-italic">
                                "Outstanding service and rapid delivery. The team's communication was excellent, making the entire process seamless."
                            </p>
                            <footer className="blockquote-footer">
                                Client A, <cite title="Source Title">Production Manager</cite>
                            </footer>
                        </blockquote>
                    </Card.Body>
                </Card>
            </Col>
            
            {/* Card 2: Client B */}
            <Col md={6} lg={4} className="mb-4">
                <Card className="shadow-lg h-100">
                    <Card.Body>
                        <blockquote className="blockquote mb-0">
                            <p className="font-italic">
                                "The team was professional and the product quality exceeded expectations. A reliable partner for our textile needs."
                            </p>
                            <footer className="blockquote-footer">
                                Client B, <cite title="Source Title">Textile Owner</cite>
                            </footer>
                        </blockquote>
                    </Card.Body>
                </Card>
            </Col>

            {/* Card 3: New/Added Card */}
            <Col md={6} lg={4} className="mb-4">
                <Card className="shadow-lg h-100">
                    <Card.Body>
                        <blockquote className="blockquote mb-0">
                            <p className="font-italic">
                                "We highly recommend their machinery. The efficiency boost has significantly improved our production margins."
                            </p>
                            <footer className="blockquote-footer">
                                Client C, <cite title="Source Title">Operations Head</cite>
                            </footer>
                        </blockquote>
                    </Card.Body>
                </Card>
            </Col>
            
            {/* To add more cards, simply copy and paste another <Col> block here */}

        </Row>
    </Container>
  );
};

export default FeedbackSection;